module.exports = __webpack_public_path__ + "static/scale-model-of-meux-home-museum-in-fresno-california-eacc5fa7b102baf1a610885df40a06f0.png";